<script>
import Vue from 'vue'
import { AgGridVue } from 'ag-grid-vue'

import RuleCollectionResource from '../../resources/ruleCollection'
import toastMixin from '../../mixins/toast'

export default Vue.extend({
    name: 'RuleCollectionGrid',
    components: {
        AgGridVue,
    },
    props: {},
    mixins: [toastMixin],
    data() {
        return {
            ruleCollectionColumnDefs: [
                {
                    field: 'id',
                    headerName: 'ID#',
                    minWidth: 70,
                    sortable: true,
                    valueSetter: () => null,
                    valueGetter: (params) => {
                        return params.data.id
                    },
                },
                {
                    field: 'name',
                    headerName: 'name',
                    minWidth: 200,
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.set('name', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.name
                    },
                },
                {
                    field: 'description',
                    headerName: 'description',
                    minWidth: 200,
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.set('description', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.description
                    },
                },
                {
                    field: 'rule_collections',
                    headerName: 'rule_collections',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.set('rule_collections', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.rule_collections
                    },
                },
                {
                    field: 'rule_groups',
                    headerName: 'rule_groups',
                    minWidth: 180,
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.set('rule_groups', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.rule_groups
                    },
                },
                {
                    field: 'rules',
                    headerName: 'rules',
                    minWidth: 250,
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.set('rules', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.rules
                    },
                },
                {
                    field: 'override_groups',
                    headerName: 'override_groups',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.set('override_groups', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.override_groups
                    },
                },
                {
                    field: 'override_rules',
                    headerName: 'override_rules',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.set('override_rules', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.override_rules
                    },
                },
                {
                    field: 'legislative_type_id',
                    headerName: 'legislative_type_id',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.set('legislative_type_id', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.legislative_type_id
                    },
                },
                {
                    field: 'status',
                    headerName: 'status',
                    sortable: true,
                    valueSetter: (params) => {
                        params.data.set('status', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.status
                    },
                },
                {
                    field: 'ot_1_hour',
                    headerName: 'ot_1_hour',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.set('ot_1_hour', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.ot_1_hour
                    },
                },
                {
                    field: 'ot_1_multiplier',
                    headerName: 'ot_1_multiplier',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.set('ot_1_multiplier', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.ot_1_multiplier
                    },
                },
                {
                    field: 'ot_2_hour',
                    headerName: 'ot_2_hour',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.set('ot_2_hour', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.ot_2_hour
                    },
                },
                {
                    field: 'ot_2_multiplier',
                    headerName: 'ot_2_multiplier',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.set('ot_2_multiplier', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.ot_2_multiplier
                    },
                },
                {
                    field: 'ot_week',
                    headerName: 'ot_week',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.set('ot_week', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.ot_week
                    },
                },
                {
                    field: 'ot_week_multiplier',
                    headerName: 'ot_week_multiplier',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.set('ot_week_multiplier', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.ot_week_multiplier
                    },
                },
                {
                    field: 'ext_reqs_url',
                    headerName: 'confluence_requirements_link',
                    sortable: true,
                    editable: true,
                    cellRenderer: (params) => {
                        if (params.data.attributes.ext_reqs_url) return `<a href="${params.data.attributes.ext_reqs_url}" target="_blank">${params.data.attributes.ext_reqs_url}</a>`
                        else return
                    },
                    valueSetter: (params) => {
                        params.data.set('ext_reqs_url', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.ext_reqs_url
                    },
                },
            ],
            ruleCollectionRowData: [],
            ruleCollectionGridOptions: {
                defaultColDef: {
                    resizable: true,
                    singleClickEdit: true,
                    undoRedoCellEditing: true,
                    enterMovesDown: true,
                    enterMovesDownAfterEdit: true,
                },
                onGridReady: (params) => {
                    if (params) {
                        this.gridApi = params.api
                        this.columnApi = params.columnApi
                    }
                },

                onFirstDataRendered: (params) => {
                    params.api.sizeColumnsToFit()
                },
            },
        }
    },
    computed: {
        resources() {
            return {
                RuleCollectionResource,
            }
        },
    },
    methods: {
        selectRuleCollection(params) {
            if (params && params.data && params.data.attributes) this.$emit('select', params.data)
        },

        async saveGrid() {
            let changes = false
            if (!this.ruleCollectionRowData || !this.ruleCollectionRowData.length) {
                this.createToast('b-toaster-top-center', 'warning', true, 'Warning', 'No Data to Save')
                return false
            }

            this.ruleCollectionRowData.forEach(async (row) => {
                if (row.changes && Object.keys(row.changes).length) {
                    changes = true
                    row.validate()
                    try {
                        await row.save()
                        row.changes = {}
                    } catch (error) {
                        this.createToast('b-toaster-top-center', 'danger', true, 'Save Error', error, true)
                        throw error
                    }
                }
            })

            if (!changes) this.createToast('b-toaster-top-center', 'warning', true, 'Warning', 'No Data to Save')
            else this.createToast('b-toaster-top-center', 'success', true, 'Success', 'Finished Save')
        },

        exportGrid() {
            this.gridApi.exportDataAsExcel()
        },
    },

    async mounted() {
        this.ruleCollectionRowData = await RuleCollectionResource.all()
    },
})
</script>

<template>
    <div>
        <div class="left"><h1>Rule Collections</h1></div>
        <div class="right">
            <b-button variant="outline-success" @click="exportGrid">Export</b-button>
            <b-button variant="primary" @click="saveGrid">Save</b-button>
        </div>
        <div class="clear"></div>
        <ag-grid-vue
            class="ag-theme-balham default-grid"
            :grid-options="ruleCollectionGridOptions"
            :column-defs="ruleCollectionColumnDefs"
            :row-data="ruleCollectionRowData"
            @row-clicked="selectRuleCollection"
        />
        <div class="clear"></div>
        <div class="right">
            <b-button variant="outline-success" @click="exportGrid">Export</b-button>
            <b-button variant="primary" @click="saveGrid">Save</b-button>
        </div>
        <div class="clear"></div>
        <hr />
    </div>
</template>

<style>
@import '../../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
@import '../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css';

.default-grid {
    width: 100%;
    height: 200px;
}
</style>
